const bootstrapPromise = import('./bootstrap');

bootstrapPromise.catch(err => console.error('[FISCAAL] bootstrap chunk FAILED', err));

